import { render, staticRenderFns } from "./discount-rule.vue?vue&type=template&id=2020e03c&scoped=true&"
import script from "./discount-rule.vue?vue&type=script&lang=ts&"
export * from "./discount-rule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020e03c",
  null
  
)

export default component.exports